import React from 'react';
export var Image = function Image(_ref) {
  var alt = _ref.alt,
      src = _ref.src,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("figure", {
    className: "image " + className
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};
export default Image;